<h2 *ngIf="dialogTitle"  role="heading"  aria-level="2" class="dialog_info-dialog-title"> {{dialogTitle}}</h2>
<div id="infoContent" class="infoDialogContent" class="dialog_info-dialog-content" [innerHTML]="dialogContent"></div>
<div class="dialog_info-dialog-button-holder">
  <button tabindex="0" role="button" mat-button mat-dialog-close class="dialog__info-dialog-button-close" attr.data-GTM={{buttonGTMTag}}>{{buttonName}}</button>
</div>